import { render, staticRenderFns } from "./ChatOrderPurchase.vue?vue&type=template&id=215be13f&scoped=true&"
import script from "./ChatOrderPurchase.vue?vue&type=script&lang=js&"
export * from "./ChatOrderPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderPurchase.vue?vue&type=style&index=0&id=215be13f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215be13f",
  null
  
)

export default component.exports